import React from 'react'
import Skills from '../components/Skills'
import Resume from '../components/Resume'
import { MainLayout } from '../styles/Layouts'

function ResumePage() {
    return (
        <MainLayout>
            <Skills/>
            <Resume/>
            
        </MainLayout>
    )
}

export default ResumePage
